import { render, staticRenderFns } from "./official_success.vue?vue&type=template&id=4bae2fb8&scoped=true&"
import script from "./official_success.vue?vue&type=script&lang=js&"
export * from "./official_success.vue?vue&type=script&lang=js&"
import style0 from "./official_success.vue?vue&type=style&index=0&id=4bae2fb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bae2fb8",
  null
  
)

export default component.exports